import React from "react";
import "./CMFoundersMessage.css";
import FounderImg from "../../assets/founder.png";

export default function FoundersMessage() {
  return (
    <section className="fm-wrapper-cmabout">
      <div className="fm-container-cmabout">

        {/* LEFT IMAGE */}
        <div className="fm-left-cmabout">
          <img src={FounderImg} alt="Founder" className="fm-founder-cmabout-img" />
        </div>

        {/* RIGHT CONTENT */}
        <div className="fm-right-cmabout">
          <h2 className="fm-title-cmabout">
            Our Founder’s<br />Message
          </h2>

          <div className="fm-divider-cmabout"></div>

          <h4 className="fm-founder-name-cmabout">
            CM. PRANESH B.E., MBA.<br />
            MANAGING DIRECTOR
          </h4>

          <p className="fm-text-cmabout">
            Welcome to CM Green Energy India Private Limited.
            When the Speed Team Group of Companies was established in 2019,
            our goal was simple yet profound: to contribute meaningfully to India’s
            sustainable future. We recognized that the transition to clean energy—
            specifically through Wind and Solar—requires not just technology, but
            unwavering commitment and unparalleled service.
          </p>

          <p className="fm-text-cmabout">
            At CM Green Energy, this belief is encapsulated in our promise of an
            extreme level of service. We don’t just build power plants; we engineer trust.
            Our teams are dedicated to delivering genuine end-to-end solutions, managing
            every complexity from the initial design phase to final grid synchronization,
            ensuring our clients receive the most robust and reliable renewable assets
            possible.
          </p>

          <p className="fm-text-cmabout">
            As a core part of the CM Group of Companies, we carry forward a legacy of
            dedication. We are deeply proud of the progress we have made and remain
            steadfast in our mission to accelerate the adoption of clean energy. Thank
            you for partnering with us as we harness the power of the sun and the wind
            to build a greener tomorrow for India.
          </p>
        </div>
      </div>
    </section>
  );
}
